import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import './i18n';

// Pages
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import ChordsPage from './pages/ChordsPage';
import ExercisesPage from './pages/ExercisesPage';
import EtudesPage from './pages/EtudesPage';
import TheoryPage from './pages/TheoryPage';
import SongsPage from './pages/SongsPage';
import TunerPage from './pages/TunerPage';
import RecorderPage from './pages/RecorderPage';
import DrumsPage from './pages/DrumsPage';
import MetronomePage from './pages/MetronomePage';
import PremiumPage from './pages/PremiumPage';
import AuthPage from './pages/AuthPage';
import ProfilePage from './pages/ProfilePage';
import TutorPage from './pages/TutorPage';
import OnboardingPage from './pages/OnboardingPage';
import SkillsPage from './pages/SkillsPage';
import ProgressPage from './pages/ProgressPage';

// Components
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-[#0A0A0A]">
          <Navbar />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/onboarding" element={<OnboardingPage />} />
            <Route path="/chords" element={<ChordsPage />} />
            <Route path="/exercises" element={<ExercisesPage />} />
            <Route path="/etudes" element={<EtudesPage />} />
            <Route path="/theory" element={<TheoryPage />} />
            <Route path="/songs" element={<SongsPage />} />
            <Route path="/tuner" element={<TunerPage />} />
            <Route path="/drums" element={<DrumsPage />} />
            <Route path="/metronome" element={<MetronomePage />} />
            <Route path="/skills" element={<SkillsPage />} />
            <Route path="/progress" element={
              <ProtectedRoute>
                <ProgressPage />
              </ProtectedRoute>
            } />
            <Route path="/premium" element={<PremiumPage />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/recorder" element={
              <ProtectedRoute>
                <RecorderPage />
              </ProtectedRoute>
            } />
            <Route path="/profile" element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            } />
            <Route path="/tutor" element={
              <ProtectedRoute>
                <TutorPage />
              </ProtectedRoute>
            } />
          </Routes>
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
